import React from "react";
import "./Management.css";

const Management = () => {
  return (
    <div className="management">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-12">
            <div className="circles">
              <div className="circle c1">
                <div className="circle c2">
                  <div className="circle c3">
                    <div className="circle c4">
                        <h1>Leverage <span>Vendor Management Software & go beyond existing capabilities</span></h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-12 cus-right">
            <div className="right-management">
                <div className="left-circle">
                <i className="fa-solid fa-users-gear"></i>
                </div>
                <div className="right-content">
                    <p>Switch from Manual to Digitized Vendor Management and track supplies & payables</p>
                </div>
            </div>
            <div className="right-management">
                <div className="left-circle">
                <i className="fa-solid fa-users-gear"></i>
                </div>
                <div className="right-content">
                    <p>Centralize vendor master data & increase transparency at all levels</p>
                </div>
            </div>
            <div className="right-management">
                <div className="left-circle">
                <i className="fa-solid fa-users-gear"></i>
                </div>
                <div className="right-content">
                    <p>Manage procurement & keep track of adherence to agreements and quality compliance</p>
                </div>
            </div>
            <div className="right-management">
                <div className="left-circle">
                <i className="fa-solid fa-users-gear"></i>
                </div>
                <div className="right-content">
                    <p>Automate vendor workflow process to meet procurement needs & drive efficiency</p>
                </div>
            </div>
            <div className="right-management">
                <div className="left-circle">
                <i className="fa-solid fa-users-gear"></i>
                </div>
                <div className="right-content">
                    <p>Helps management and all key stakeholders to track all procurements and payments</p>
                </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Management;
